/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/809/interface/api/cat_9002
 */

import { message } from 'ant-design-vue'
import { pkg_list_post, pkg_release_get } from 'server/modules/9002'

// 多语言发布包列表
export const pkg_list_post_ = async function(params) {
  const { success, data, retInfo } = await pkg_list_post(params)
  if (success) {
    return Promise.resolve(data)
  } else {
    message.error(retInfo)
    return Promise.reject(data)
  }
}

// 发布多语言包
export const pkg_release_get_ = async function(state) {
  const { success, retInfo } = await pkg_release_get()
  if (success) {
    state.initList()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
